import axiosApi from '@apis/axiosApi'
import { handleError } from '@utils/commonUtils'
import * as queryString from 'query-string'

const BASE = '/hanh-chinh/danh-muc-tai-san'

export function locDanhMucTaiSan(querySt?: string | Record<string, unknown>) {
  try {
    const query =
      querySt == null ? {} : typeof querySt === 'string' ? queryString.parse(querySt) : querySt
    return axiosApi.get(`${BASE}/loc-danh-sach`, { params: query || {} })
  } catch (err: any) {
    handleError(err)
    throw err
  }
}

export function layChiTietDanhMucTaiSan(categoryId: number) {
  try {
    return axiosApi.get(`${BASE}/${categoryId}/chi-tiet`)
  } catch (err: any) {
    handleError(err)
    throw err
  }
}

export function taoDanhMucTaiSan(params: any) {
  try {
    return axiosApi.post(`${BASE}/tao`, params)
  } catch (err: any) {
    handleError(err)
    throw err
  }
}

export function capNhatDanhMucTaiSan(categoryId: number, params: any) {
  try {
    return axiosApi.put(`${BASE}/${categoryId}/cap-nhat`, params)
  } catch (err: any) {
    handleError(err)
    throw err
  }
}

export function xoaDanhMucTaiSan(categoryId: number) {
  try {
    return axiosApi.delete(`${BASE}/${categoryId}/xoa`)
  } catch (err: any) {
    handleError(err)
    throw err
  }
}
